
import { defineComponent } from 'vue';
import * as _ from 'lodash';
import { UPLOAD_SIZE_STRING, _Util } from '@/MyUtil';
import { _ServerApi } from '@/serverAPI';

export default defineComponent({
  name: 'public_doc_list',
  props: [
    "openType"
  ],

  data() {
    return {
      "util": _Util.getInstance(),
      "is_loading": true,
      "test_arr": _.range(0, 100),
      "is_writer": false,
      "board_list": [] as IBoardListItem[],
      "list_count" : 20,
      "is_last_doc" : false,
      "search_val" : "",
    }
  },
  computed:{
    is_show_search_menu(){
      return this.openType == "";
    }
  },

  components: {
  },
  methods: {
    add_noti(msg: string) {
      this.util.add_noti({
        vue_ele: this.$root,
        msg: msg
      });
    },

    getImg(file_name: string) {
      return this.util.getImgURL(file_name, UPLOAD_SIZE_STRING.S_540X283);
    },

    getWriter(email: string) {
      const writer = email.split("@");
      if (writer.length <= 1) {
        return "none";
      }
      return writer[0];
    },

    getOpenTypeText(open_type: number) {
      if (open_type == 0) {
        return "작성중";
      }
      else if (open_type == 1) {
        return "비공개";
      }
      else if (open_type == 2) {
        return "공개";
      }
      else {
        return "none";
      }
    },

    clickGoToView(url_key:string){
      window.open(`/v/${url_key}`, '_blank');
      
    },

    clickWriteGo() {
      this.$router.push("/BoardWrite");
    },

    async clickMoreList(){
      if(this.board_list.length == 0){
        this.add_noti("더이상 값이 없습니다.");
        return;
      }
      const d = _.last(this.board_list);
      console.log(d);

      let board_idx = "";
      if(!_.isUndefined(d?.board_idx)){
        board_idx = d?.board_idx + "";
      }
      console.log(board_idx);
      const list = await this.getListData(board_idx);
      if(list.length == 0){
        this.is_last_doc = true;
        this.add_noti("더 문서가 없습니다.");
        return;
      }

      console.log(list);

      list.forEach(d=>{
        this.board_list.push(d);
      });


    },

    async getListData(next_idx: string): Promise<IBoardListItem[]> {
      ///api/getBoardList
      const _api = _ServerApi.getInstance();

      const result = await _api.postJson("/api/getBoardList", {
        "open_type": this.openType,
        next_idx: next_idx,
      });

      if (result.isError) {
        this.add_noti(result.msg);
        return [];
      }

      const list: IBoardListItem[] = result.list;
      if(list.length != this.list_count){
        this.is_last_doc = true;
      }
      return list;
    },

    async search_go(){
      const util = this.util;


      if (this.search_val.length != 0) {
        if (this.search_val.length <= 1) {
          this.add_noti("검색어를 2자 입력하세요.");
          return;
        }
      }
      if(util.isSpecialWord(this.search_val)){
        this.add_noti("특수문자는 입력 불가능 합니다.");
        return;
      }

      
      const _api = _ServerApi.getInstance();
      const result = await _api.postJson("/api/getBoardList", {
        "open_type": this.openType,
        "search_val" : this.search_val,
        next_idx: "",
      });
      if (result.isError) {
        this.add_noti(result.msg);
        return;
      }
      //console.log(result);
      const list = result.list;
      _.each(list, (d) => {
        d.write_date = util.getDateJSONDate(d.write_date as string);
        const format = util.getDateFnsForamt();
        d.write_date_text = format(d.write_date, "yy.MM.dd");
      });
      this.board_list = list;

    },


  },

  async mounted() {
    const util = this.util;
    const login_info = util.getLoginInfo(this.$cookies);
    this.is_writer = login_info.is_writer;

    util.setLoading({
      vue_ele: this.$root,
      isLoading: true,
    })
    await util.waitTime(500);
    const board_list = await this.getListData("");
    _.each(board_list, (d) => {
      d.write_date = util.getDateJSONDate(d.write_date as string);
      const format = util.getDateFnsForamt();
      d.write_date_text = format(d.write_date, "yy.MM.dd");
    });

    console.log(board_list);

    this.board_list = board_list;
    util.setLoading({
      vue_ele: this.$root,
      isLoading: false,
    })
    return "";

  },

  async unmounted() {
    console.log("unmounted")
  }


});

interface IBoardListItem {
  "board_idx" : number,
  "open_type": number,
  "url_key": string,
  "title": string,
  "main_img": string,
  "sub_title": string,
  "write_date": Date | string,
  "writer": string,
  "write_date_text": string,


}
